
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expertise/construction",
      function () {
        return require("private-next-pages/expertise/construction.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expertise/construction"])
      });
    }
  